App.Lang =
  {
    language: "fi",
    translations:
      {
        fi:
          {
            add_new_user: "Lisää uusi käyttäjä",
            cancel: "Peruuta",
            save: "Tallenna",
            invite: "Kutsu",
            email: "Sähköposti",
            name: "Nimi",
            error_ajax: "Virhe yhteydessä palveluun",
            ok: "OK",
            field_name: "Nimi",
            field_email: "Sähköposti",
            field_text: "Teksti",
            add_new_page: "Lisää sivu",
            add_new_element: "Lisää",
            confirm_delete: "Haluatko varmasti poistaa?",
            new_environment: "Uusi ympäristö",
            edit_environment: "Muokkaa ympäristöä",
            edit_page: "Muokkaa sivua",
            no_messages_yet: "Ei vielä viestejä"
          },
        en:
          {
            add_new_user: "Add a new user",
            cancel: "Cancel",
            save: "Save",
            invite: "Invite",
            email: "Email",
            name: "Name",
            error_ajax: "Error connecting to the service",
            ok: "OK",
            field_name: "Name",
            field_email: "Email",
            field_text: "Text",
            add_new_page: "Add a new page",
            add_new_element: "Add new",
            confirm_delete: "Are you sure you want to delete this?",
            new_environment: "New environment",
            edit_environment: "Edit environment",
            edit_page: "Edit page",
            no_messages_yet: "No messages yet"
          }
      },

    get: function (token) {
      return typeof App.Lang.translations[App.Lang.language][token] === "undefined" ? token : App.Lang.translations[App.Lang.language][token];
    },

    getLanguage: function () {
      return App.Lang.language;
    },

    setLanguage: function (language) {
      App.Lang.language = language;
    },

    getLangPackDropzone: function () {
      let language = App.Lang.getLanguage();

      if (language === "fi") {
        return {
          dictDefaultMessage: "Lataa tiedosto raahaamalla tähän tai napauttamalla tästä",
          dictFallbackMessage: "Selaimesi ei tue tiedostojen lataamista raahaamalla.",
          dictFallbackText: "Ole hyvä ja käytä alla olevaa varalatauslomaketta.",
          dictFileTooBig: "Tiedosto on liian suuri ({{filesize}}MiB). Enimmäiskoko on: {{maxFilesize}}MiB.",
          dictInvalidFileType: "Tiedoston tyyppi ei ole sallittu.",
          dictResponseError: "Palvelin vastasi koodilla {{statusCode}}.",
          dictCancelUpload: "Peruuta lataus",
          dictUploadCanceled: "Lataus peruutettu.",
          dictCancelUploadConfirmation: "Haluatko varmasti peruuttaa tämän latauksen?",
          dictRemoveFile: "Poista tiedosto",
          dictMaxFilesExceeded: "Et voi ladata enempää tiedostoja."
        };
      }

      return {};
    },

    setLightboxDefaults: function(lightbox) {
      let language = App.Lang.getLanguage();

      if (language === "fi") {
        lightbox.option({
          "albumLabel": "Kuva %1 / %2"
        })
      }
    }

  };
